import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    SimpleChange,
    SimpleChanges,
    ViewChild,
} from '@angular/core'
import { Observable, Subject, Subscription } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { AuthService, ClientTopServices, MatrixServices, RestServices } from '@app/services'
import { fromEvent } from 'rxjs/observable/fromEvent'
import { getImageRedirectUrl, handleImageError } from '@helpers/common'
import { notification } from 'onsenui'
import * as _html2canvas from 'html2canvas'
const html2canvas: any = _html2canvas

@Component({
    selector: 'app-base-image',
    templateUrl: './base-image.component.html',
    styleUrls: ['./base-image.component.css'],
})
export class BaseImageComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() isEdit = false
    @Input() isTopTooth = false
    @Input() imageId: string
    @Input() imageSrc: string
    @Input() imageIndex: number
    @Input() imageWrapper: HTMLDivElement
    @Input() arrImageUrl: any[]
    @Input() arrImageId: any[]
    @Input() matrixImage: any[]
    @Input() imageStyle: any
    @Input() arrStyleImage: any[]
    @Input() id: string
    @Input() page?: string
    @Input() settingImageData?: any
    @ViewChild('wrapper', { read: false }) wrapper: ElementRef
    @ViewChild('link', { read: false }) link: ElementRef
    @ViewChild('printEleStyle', { read: false }) printEleStyle: ElementRef

    initialize = false
    loading = false
    fetchedImage = false
    images: Subject<string> = new Subject<string>()
    image: HTMLImageElement
    removeImage: HTMLImageElement
    imageListObservable: Observable<any>
    imageListSubscription: Subscription
    matrixStyle: any
    currentUrl: string
    timeForShowLoading = 1000
    countRotateRight = 0
    countRotateLeft = 0
    stylePrint = ''
    css = ''   
    printStyle_
    removePrt: HTMLImageElement
    applyDefaultSubscription: Subscription

    constructor(
        private renderer: Renderer2,
        private clientTopServices: ClientTopServices,
        private matrixServices: MatrixServices,
        private authData: AuthService,
        private restApi: RestServices,
    ) {
    }

    ngOnInit() {
        this.imageListObservable = this.images.pipe(
            debounceTime(400),
            distinctUntilChanged(),
        )
        this.imageListSubscription = this.imageListObservable.subscribe(
            (image) => {
                this.prependImage(image)
                this.reRenderMatrix()
                if (this.isTopTooth && !this.applyDefaultSubscription) {
                    this.applyDefaultStyle()
                }
            },
        )
        fromEvent(window, 'resize').subscribe((evt) => {
            this.reRenderMatrix()
        })
    }

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges(changes: SimpleChanges) {
        const currentItem: SimpleChange = changes.imageSrc
        const maxtrixChange: SimpleChange = changes.matrixImage
        const arrImageUrl: SimpleChange = changes.arrImageUrl
        const arrStyleImage: SimpleChange = changes.arrStyleImage
        // if (arrStyleImage) {
        //     this.reRenderMatrix()
        // }
        if (currentItem) {
            const image = currentItem.currentValue
            this.images.next(image)
        } else if (arrStyleImage) {
            this.reRenderMatrix()
        } else if (arrImageUrl && this.isEdit) {
            const image = arrImageUrl.currentValue[this.imageIndex]
            this.prependImage(image)
        } else if (maxtrixChange) {
            this.reRenderMatrix()
        }
    }

    ngAfterViewInit(): void {
        this.images.next(this.imageSrc)
        this.initialize = true
    }

    ngOnDestroy() {
        if (this.isTopTooth && this.applyDefaultSubscription) {
            this.applyDefaultSubscription.unsubscribe()
        }
    }

    handleError() {
        const imageUri = handleImageError(this.image.src)
        if (imageUri) {
            this.image.src = imageUri
        }
    }

    showBigImage() {
        const emitArr: any = {}

        if (this.imageId) {
            emitArr['id'] = this.imageId
        } else {
            emitArr['id'] = this.arrImageId[this.imageIndex]['id']
        }
        emitArr['showBigImageModal'] = true
        emitArr['isEdit'] = this.isEdit
        emitArr['imageIndex'] = this.imageIndex
        emitArr['matrix'] = this.matrixImage[this.imageIndex]
        emitArr['style'] = this.arrImageId[this.imageIndex]['style']
            ? this.arrImageId[this.imageIndex]['style']
            : this.imageStyle
                ? this.imageStyle
                : {}
        emitArr['baseImage'] = this
        if(this.page && this.page == "dental") emitArr['pageInput'] = "dental";

        this.clientTopServices.emitChange(emitArr)
    }

    loadedImage() {
        this.reRenderMatrix()
        this.image.className = 'showing'
        setTimeout(() => {
            this.fetchedImage = true
        }, 200)

        this.removeOldImage()
        this.loading = false
    }

    prependImage(image, className = 'img-hide') {
        let src = image
        this.resetValue()

        if (image && image['id']) {
            let imageId = image['id']
            this.imageId = imageId
            src = getImageRedirectUrl(imageId)
        }

        if (this.currentUrl != src) {
            this.currentUrl = src
            if (this.wrapper) {
                // remove image
                if (this.image) {
                    if (!src) {
                        this.loading = false
                        this.removeImage = this.image
                        this.removeOldImage('hiding-fast', 300)
                    } else {
                        if (this.removeImage) {
                            this.renderer.removeChild(
                                this.wrapper.nativeElement,
                                this.removeImage,
                            )
                            this.removeImage = null
                        }
                        this.removeImage = this.image
                    }
                }
                if (src) {
                    setTimeout(() => {
                        if (this.image.className !== 'showing') {
                            this.loading = true
                        }
                    }, this.timeForShowLoading)
                    this.fetchedImage = false
                    this.image = this.renderer.createElement('img')
                    this.image.src = src
                    this.image.className = className
                    this.image.onerror = () => this.handleError()
                    this.image.onload = () => this.loadedImage()
                    this.image.onclick = () => this.showBigImage()
                    this.renderer.appendChild(
                        this.wrapper.nativeElement,
                        this.image
                    )
                    this.image.id = this.id
                }
            }
        }
    }

    removeOldImage(className = 'hiding', timeout = 1000) {
        if (this.removeImage) {
            this.removeImage.className = className
            setTimeout(() => {
                if (this.removeImage) {
                    this.renderer.removeChild(
                        this.wrapper.nativeElement,
                        this.removeImage,
                    )
                    this.removeImage = null
                }
                this.fetchedImage = true
            }, timeout)
        }
    }

    reRenderMatrix() {
        this.matrixServices.loadSizeImage(
            this.image,
            this.imageWrapper,
            this.imageIndex,
            this.matrixImage,
            this.arrImageUrl,
            this.arrImageId,
        )
        this.applyMatrixStyle()
        this.applyStyleImage()
    }

    defaultRotate(imageWrapper, rotateType) {
        this.matrixServices.defaultRotate(
            this.imageIndex,
            this.matrixServices.arrRotate[this.imageIndex],
            this.image,
            imageWrapper,
            rotateType,
            this.matrixServices.arrFlip[this.imageIndex]['horizontalFlip'],
            this.matrixServices.arrFlip[this.imageIndex]['verticalFlip'],
        )
        this.applyMatrixStyle()
        this.applyStyleImage()
    }

    rotateLeft() {
        this.rotateImage(-90)
    }

    rotateRight() {
        this.rotateImage(90)
    }

    rotateImage(number) {
        if (this.arrImageId[this.imageIndex]['style']) {
            let data = this.arrImageId[this.imageIndex]['style']['rotate']
            this.arrImageId[this.imageIndex]['style']['rotate'] = data
                ? data + number
                : number
        } else {
            this.arrImageId[this.imageIndex]['style'] = {}
            this.arrImageId[this.imageIndex]['style']['rotate'] = number
        }
        this.applyStyleImage(true)
        this.updateData()
    }

    findCountRotate() {
        const rotate = this.arrImageId[this.imageIndex]['style']['rotate']
        if (rotate) {
            let mod = rotate ? rotate % 90 : 0
            this.caculatorCountRotate(mod, rotate)
        }
    }

    caculatorCountRotate(mod, imgRotate) {
        const numberRotate = (imgRotate - mod) / 90
        if (numberRotate > 0) {
            this.countRotateRight = Math.abs(numberRotate)
        } else {
            this.countRotateLeft = Math.abs(numberRotate)
        }
        if (Math.abs(mod) > 30) {
            if (mod > 0) {
                this.countRotateRight++
            } else {
                this.countRotateLeft++
            }
        }
    }

    flipXFunction(value) {
        if (this.arrImageId[this.imageIndex]['style']) {
            this.findCountRotate()
            const denta =
                this.countRotateLeft < this.countRotateRight
                    ? this.countRotateRight - this.countRotateLeft
                    : this.countRotateLeft - this.countRotateRight
            if (denta % 2 !== 0) {
                this.arrImageId[this.imageIndex]['style']['scaleY'] = this
                    .arrImageId[this.imageIndex]['style']['scaleY']
                    ? this.arrImageId[this.imageIndex]['style']['scaleY'] * -1
                    : -1
            } else {
                this.arrImageId[this.imageIndex]['style']['scaleX'] = this
                    .arrImageId[this.imageIndex]['style']['scaleX']
                    ? this.arrImageId[this.imageIndex]['style']['scaleX'] * -1
                    : -1
            }
        } else {
            this.arrImageId[this.imageIndex]['style'] = {}
            this.arrImageId[this.imageIndex]['style']['scaleX'] = -1
        }
        this.applyStyleImage(true)
        if (this.image) {
            this.updateData()
        } else {
            this.updateDataWithoutImageTag()
        }
    }

    flipYFunction(value) {
        if (this.arrImageId[this.imageIndex]['style']) {
            this.findCountRotate()
            const denta =
                this.countRotateLeft < this.countRotateRight
                    ? this.countRotateRight - this.countRotateLeft
                    : this.countRotateLeft - this.countRotateRight
            if (denta % 2 === 0) {
                this.arrImageId[this.imageIndex]['style']['scaleY'] = this
                    .arrImageId[this.imageIndex]['style']['scaleY']
                    ? this.arrImageId[this.imageIndex]['style']['scaleY'] * -1
                    : -1
            } else {
                this.arrImageId[this.imageIndex]['style']['scaleX'] = this
                    .arrImageId[this.imageIndex]['style']['scaleX']
                    ? this.arrImageId[this.imageIndex]['style']['scaleX'] * -1
                    : -1
            }
        } else {
            this.arrImageId[this.imageIndex]['style'] = {}
            this.arrImageId[this.imageIndex]['style']['scaleY'] = -1
        }
        this.applyStyleImage(true)
        if (this.image) {
            this.updateData()
        } else {
            this.updateDataWithoutImageTag()
        }
    }

    updateData() {
        const style = this.getStyle()
        const emmitData = {
            imageId: this.arrImageId[this.imageIndex]['id'],
            imageIndex: this.imageIndex,
            style: style,
        }
        this.clientTopServices.emitSimpleEdit(emmitData)
    }

    // when flipXfunction and flipYfunction run, this.updateData() does not
    // update the new image style correctly the first time if this.image
    // is not created
    updateDataWithoutImageTag() {
        const emitData = {
            imageId: this.arrImageId[this.imageIndex]['id'],
            imageIndex: this.imageIndex,
            style: this.arrImageId[this.imageIndex]['style'],
        }
        this.clientTopServices.emitSimpleEdit(emitData)
    }

    applyStyleImage(withSave = false, style = null) {
        if (this.imageStyle) {
            style = this.imageStyle
        }
        if (!style) {
            style =
                this.arrImageId &&
                this.arrImageId[this.imageIndex] &&
                this.arrImageId[this.imageIndex]['style']
                    ? this.arrImageId[this.imageIndex]['style']
                    : {}
        }
        let object: any = {}
        if (this.image) {
            object = this.parseObjectTranform(this.image.style.transform)
        }
        if (this.image != undefined && style != undefined) {
            if (style.rotate != undefined) {
                object.rotate = style.rotate + 'deg'
            }
            if (style.scaleX != undefined) {
                object.scaleX = style.scaleX + ''
            }
            if (style.scaleY != undefined) {
                object.scaleY = style.scaleY + ''
            }
        }
        this.updateStyle(object)
        if (withSave) {
            window['canvasChange'] = true
        }
    }
    
    applyDefaultStyle() {
        this.applyDefaultSubscription = this.clientTopServices.changeEmittedUploadImageIndex$.subscribe(imgIndex => {
            const isNewUpload = imgIndex === this.imageIndex
            if(!isNewUpload || !this.settingImageData || !this.isTopTooth ) {
               return
             } else {
               const styleConfig = this.settingImageData[this.renderSettingImagePropertyName(this.imageIndex)];
               if(styleConfig && typeof styleConfig == 'number' && styleConfig !== 0) {
                    this.arrImageId[this.imageIndex].style = {
                        rotate: 0,
                        scaleX: 1,
                        scaleY: 1,
                    }
                    this.countRotateLeft = 0
                    this.countRotateRight = 0
                    switch (styleConfig) {
                        case 1:
                            this.flipYFunction(event)
                            break
                        case 2:
                            this.flipXFunction(event)
                            break
                        default:
                            break
                    }
                }
            }
        })
    }

    renderSettingImagePropertyName(index): string {
        let propertyName = ''
        switch (index) {
            case 0:
                propertyName = 'right'
                break
            case 1:
                propertyName = 'front'
                break
            case 2:
                propertyName = 'left'
                break
            case 3:
                propertyName = 'upper'
                break
            case 4:
                propertyName = 'overjet'
                break
            case 5:
                propertyName = 'lower'
                break
            default:
                break
        }
        return propertyName
    } 

    private getStyle(): any {
        let object: any = {}
        if (this.image) {
            object = this.parseObjectTranform(this.image.style.transform)
        }
        return {
            rotate: this.getRotateImage(object['rotate']),
            scaleX: Number(object['scaleX'] ? object['scaleX'] : 1),
            scaleY: Number(object['scaleY'] ? object['scaleY'] : 1),
        }
    }

    getRotateImage(rotateCss) {
        try {
            return Number((rotateCss ? rotateCss : 0).replace('deg', ''))
        } catch (error) {
            return 0
        }
    }

    updateStyle(object) {
        let string = ''
        for (const key in object) {
            string += key + '(' + object[key] + ') '
        }
        if (this.image) {
            this.image.style.transform = string;
            const n = string.indexOf("rotate");
            let scaleX = 1;
            if(object.matrix) {
                let n1 = object.matrix.split(",");
                if(n1 < 0) {
                    scaleX = -1;
                }
            }
            const strNotMatrix = string.slice(n, string.length);
            
            this.css = 'transform: translate(-50%, -50%)' + strNotMatrix + ` scaleX(${scaleX}) ` + '!important;\n';
            this.css += '-ms-transform: translate(-50%, -50%)' + strNotMatrix + ` scaleX(${scaleX}) `+ '!important;\n';
            this.css += '-webkit-transform: translate(-50%, -50%)' + strNotMatrix + ` scaleX(${scaleX}) `+ '!important;\n';
            this.css += '-moz-transform: translate(-50%, -50%)' + strNotMatrix + ` scaleX(${scaleX}) ` + '!important;\n';


            const style = document.createElement('style');

            style.type = 'text/css';
            style.appendChild(document.createTextNode("@media print { \n #" + this.image.id + " {\n" + this.css + "} \n}"));

            if (this.printStyle_) {
                this.renderer.removeChild(
                    this.printEleStyle.nativeElement,
                    this.printStyle_,
                )
                this.removePrt = null
                this.printStyle_ = null
            }
            this.printStyle_ = style
            this.renderer.appendChild(this.printEleStyle.nativeElement, style)
        }
    }

    parseObjectTranform(stringTranform) {
        const regex = /(\w+)\((.+?)\)/g
        let transform = {}
        let matchS: any
        while ((matchS = regex.exec(stringTranform))) {
            transform[matchS[1]] = matchS[2]
        }
        return transform
    }

    applyMatrixStyle() {
        if (this.image) {
            this.matrixStyle = this.matrixServices.arrStyleImage[
                this.imageIndex
                ]
            if (this.matrixStyle) {
                this.image.style.transform = this.matrixStyle.transform
            } else if (
                this.matrixStyle &&
                this.matrixStyle == 'transform: matrix(1, 0, 0, 1, 0, 0)'
            ) {
                this.image.style.transform = this.matrixServices.arrStyleImage[3].transform
            } else if (
                !this.matrixStyle ||
                this.matrixStyle == undefined ||
                this.matrixStyle == null
            ) {
                this.matrixStyle = this.matrixServices.arrStyleImage[3]
                if (this.matrixStyle) {
                    this.image.style.transform = this.matrixStyle.transform
                }
            }
        }
    }

    download(style = null, url, link1, domDownloadImage) {
        if (!style) {
            style = this.arrImageId[this.imageIndex]['style']
        }
        this.convertImageToCanvas(url, link1, domDownloadImage, style)
    }

    downloadImage(item, download1, domDownloadImage) {
        this.convertImageToCanvas(
            this.arrImageId[item]['id'],
            download1,
            domDownloadImage,
            this.arrImageId[item]['style'],
        )
    }

    convertImageToCanvas(id, download, domDownloadImage, style) {
        this.authData.authToken().then((tokenReNew) => {
            this.restApi
            .http_get('image/v0.0.9/status/' + id, tokenReNew)
            .subscribe((success) => {
                this.getBase64FromImageUrl(
                    success['url'],
                    domDownloadImage,
                    download,
                    id,
                    style,
                )
            })
        })
    }

    findMatrixImage(
        widthBigImageHeight,
        widthBigImageWidth,
        sizeImage,
        matrixImage = [1, 0, 0, 1],
    ) {
        const widthRatio = widthBigImageWidth / sizeImage.width
        const heightRatio = widthBigImageHeight / sizeImage.height
        const ratioMin = widthRatio < heightRatio ? widthRatio : heightRatio
        const n1 = ratioMin * matrixImage[0] // n1
        const n2 = (widthBigImageHeight / sizeImage.width) * matrixImage[1] // n2
        const n3 = (widthBigImageWidth / sizeImage.width) * matrixImage[2] // n3
        const n4 = ratioMin * matrixImage[3] // n4
        const n5 = (widthBigImageWidth - sizeImage.width) / 2
        const n6 = (widthBigImageHeight - sizeImage.height) / 2
        return (
            'matrix(' +
            n1 +
            ', ' +
            n2 +
            ', ' +
            n3 +
            ', ' +
            n4 +
            ',' +
            n5 +
            ',' +
            n6 +
            ') '
        )
    }

    getBase64FromImageUrl(URL, domDownloadImage, download, id, style) {
        const img = new Image()
        domDownloadImage.innerHTML = ''
        img.setAttribute('crossOrigin', 'anonymous')
        img.onload = () => {
            domDownloadImage.style.width = 1200 + 'px'
            domDownloadImage.style.height = 800 + 'px'
            if (style) {
                img.style.transform =
                    this.findMatrixImage(
                        domDownloadImage.clientHeight,
                        domDownloadImage.clientWidth,
                        img,
                    ) +
                    ' rotate(' +
                    (style.rotate ? style.rotate : 0) +
                    'deg)'
                const scaleX = style.scaleX ? style.scaleX : 1
                const scaleY = style.scaleY ? style.scaleY : 1
                img.style.transform +=
                    ' scaleX(' + scaleX + ') scaleY(' + scaleY + ')'
            } else {
                img.style.transform = this.findMatrixImage(
                    domDownloadImage.clientHeight,
                    domDownloadImage.clientWidth,
                    img,
                )
            }
            domDownloadImage.appendChild(img)
            html2canvas(domDownloadImage, {
                logging: true,
                letterRendering: 1,
                allowTaint: false,
                useCORS: true,
            }).then(function(canvas) {
                canvas.toBlob(function(blob) {
                    const href = window.URL.createObjectURL(blob)
                    const download = id + '.jpeg'
                    notification.confirm({
                        message: 'Click to download file.',
                        title: '<b>Download</b>',
                        buttonLabels: [
                            '<a download=\'' +
                            download +
                            '\' href=\'' +
                            href +
                            '\' class=\'download-btn\' style=\'width: 100%;height: 100%;display: table; text-decoration: none;\'>OK</a>',
                        ],
                    })
                }, 'image/jpeg')
            })
        }
        img.src = URL
    }

    resetValue() {
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/base-image/base-image.component.ts